import { useQuery } from "@apollo/client";
import { PROJECT } from "../graphql/gqlProject";
import { useParams } from "react-router-dom";
import {
  BipodLashing,
  Pole,
  Poleset,
  ScaffoldLashing,
  TripodLashing,
} from "../graphql/gqlTypes";
import { SquareLashing } from "../graphql/gqlTypes";

export const defaultPoleset: Poleset = {
  id: "__default__",
  name: "default poleset",
  poles: [
    { id: "1", length: 1, color: "#ffa500", radius: 0.06 },
    { id: "1.5", length: 1.5, color: "#00ff00", radius: 0.06 },
    { id: "2", length: 2, color: "#ff0000", radius: 0.06 },
    { id: "2.5", length: 2.5, color: "#037c6e", radius: 0.06 },
    { id: "3", length: 3, color: "#ffffff", radius: 0.06 },
    { id: "4", length: 4, color: "#0000ff", radius: 0.06 },
    { id: "5", length: 5, color: "#ffff00", radius: 0.06 },
    { id: "6", length: 6, color: "#000000", radius: 0.06 },
  ],
};

export const useInventory = () => {
  const { projectId } = useParams();
  const { data, loading } = useQuery(PROJECT, {
    variables: { id: projectId },
    pollInterval: 30000,
  });

  const dbPoles: Pole[] = data?.getProjectById.poles || [];
  const dbLashings: SquareLashing[] = data?.getProjectById.lashings || [];
  const dbBipodLashings: BipodLashing[] =
    data?.getProjectById.bipodLashings || [];
  const dbTripodLashings: TripodLashing[] =
    data?.getProjectById.tripodLashings || [];
  const dbScaffoldLashings: ScaffoldLashing[] =
    data?.getProjectById.scaffoldLashings || [];
  const polesetData: Poleset = data?.getProjectById.poleset || defaultPoleset;
  const poleset: Poleset = {
    ...polesetData,
    poles: [...polesetData.poles].sort((a, b) => a.length - b.length),
  };

  return {
    dbPoles,
    dbLashings,
    dbBipodLashings,
    dbTripodLashings,
    dbScaffoldLashings,
    poleset,
    projectLoading: loading,
  };
};
